<template>
  <dilazioni />
</template>

<script>
import Dilazioni from '@/components/ask/pages/dilazioni/All.vue'


export default {
  name: 'DilazioniAll',

  components:{
    Dilazioni
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
